import VoiceScreeningEmbed from "@/components/VoiceScreeningEmbed";

/**
 * /screening — dedicated page that embeds the Streamlit voice screening
 * tool. Reached from the Home hero "Start voice screening" button.
 */
export default function Screening() {
  return (
    <div data-testid="screening-page">
      <VoiceScreeningEmbed />
    </div>
  );
}
